import DriverColumnCard from "../components/DriverColumnCard";
import DriverRouteCard from "../components/DriverRouteCard";
import reportConstants from "../constants";
import { getEquipmentSuffix } from "../../../Dispatch/utils/utils";
const ganttConfig = (theme, DispatchStore, enableReturnExceptionReasonLabels = false) => ({
  columns: [
    {
      name: "external",
      label: "",
      align: "center",
      onrender: (item) => {
        return item.type === "project" ? (
          <DriverColumnCard
            data={item}
            theme={theme}
            DispatchStore={DispatchStore}
            enableReturnExceptionReasonLabels={enableReturnExceptionReasonLabels}
          />
        ) : (
          <DriverRouteCard data={item} theme={theme} />
        );
      },
    },
  ],
  scale_height: 62,
  min_column_width: 125,
  row_height: 40,
  bar_height: 37,
  grid_elastic_columns: true,
  initial_scroll: false,
});

const getGanttTemplates = (showTrailerScac, theme) => ({
  grid_row_class: (start, end, task) => {
    if (task.isDriverDelayed) return "delayedRow";
  },
  task_row_class: (start, end, task) => {
    const rowClassList = [];
    if (task.isDriverDelayed) rowClassList.push("delayedRow");
    if (task.isLastRow) rowClassList.push("lastRow");
    return rowClassList.join(" ");
  },
  task_class: (start, end, task) => {
    let classList = [];
    classList.push(task.type);
    if (task.isCurrentStop) {
      classList.push("currentStop");
    }
    return classList.join(" ");
  },
  rightside_text: (start, end, task) => {
    if (
      [
        reportConstants.REPORT_STOP_TYPES.trailerDrop,
        reportConstants.REPORT_STOP_TYPES.trailerHook,
      ].includes(task.type)
    ) {
      const trailerNumberWithScacCode = `${task.routeData.trailerNumber} 
        ${getEquipmentSuffix({
          equipmentScac: task.routeData.trailerScac,
          showTrailerScac,
        })
      }`;
      return `Trailer ${trailerNumberWithScacCode}`;
    }
  },
});

const getGanttLayout = (
  showTrailerScac,
  theme,
  DispatchStore,
  enableReturnExceptionReasonLabels = false
) => ({
  css: "gantt_container",
  cols: [
    {
      width: 290,
      min_width: 250,
      rows: [
        {
          view: "grid",
          scrollY: "scrollVer",
          config: ganttConfig(theme, DispatchStore, enableReturnExceptionReasonLabels),
          templates: getGanttTemplates(showTrailerScac, theme),
        },
      ],
    },
    { resizer: true, width: 0 },
    {
      rows: [
        {
          view: "timeline",
          scrollX: "scrollHor",
          scrollY: "scrollVer",
          config: ganttConfig(theme, DispatchStore, enableReturnExceptionReasonLabels),
          templates: getGanttTemplates(showTrailerScac, theme),
        },
        { view: "scrollbar", id: "scrollHor", group: "horizontal" },
      ],
    },
    { view: "scrollbar", id: "scrollVer" },
  ],
});

const getGanttZoomConfig = () => {
  return reportConstants.DEFAULT_SCALE_LEVELS.map((scaleOption) => [
    {
      unit: scaleOption.unit,
      format: "%H:%i",
      step: scaleOption.value,
    },
  ]);
};

export { getGanttLayout, getGanttZoomConfig };
